import { render, staticRenderFns } from "./ProcedimientosDeSeguridad.vue?vue&type=template&id=47732793"
import script from "./ProcedimientosDeSeguridad.vue?vue&type=script&lang=js"
export * from "./ProcedimientosDeSeguridad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports